import React, { Fragment } from "react";
import { Player } from "video-react";
import "../../../../node_modules/video-react/dist/video-react.css";
import UploadVideo from "site_media/images/Settings_Camera.png";
import "components/General/Video/Video.css";
import Image from "react-bootstrap/Image";
import CustomImagePopup from "../Form/Popup/CustomImagePopup";
import CustomCreationSuitePopup from "../Form/Popup/CustomCreationSuitePopup";
class Video extends React.Component {
  render() {
    const { fileType, src } = this.props;
    return (
      <Fragment>
        <div
          className="project-video-preview"
          style={{ width: this.props.width }}
        >
          {fileType === "image" ? (
            <Image src={src} className="w-100" />
          ) : fileType === "video" ? (
            <Player
              className="video-upload-preview"
              fluid={false}
              playsInline
              src={src}
            />
          ) : null}
        </div>
        <div className="project-video" style={{ width: this.props.width }}>
          <img className="project-video-upload" src={UploadVideo} alt="" />
          <div className="video-text">
            <label className="upload-video" htmlFor="file" onClick={this.props.openPopUp}>
              Upload  Video / Photo
            </label>
          </div>
        </div>
        {(this.props.displayImagePopup || this.props.displayCustomPopup) && this.props.imagePopup  ? (
          <CustomImagePopup
            isOpen={true}
            count={this.props.count}
            closePopUp={this.props.closePopUp}
            handleImageChange = {this.props.onChange}
            fileUpload={this.props.fileUpload}
            uploadApi={this.props.uploadApi}
            openCreationSuite={this.props.openCreationSuite}
          />
        ) : null}
        {this.props.displayCreationSuite ? (
          <CustomCreationSuitePopup
            isOpen={true}
            fileData = {this.props.fileData}
            closeCreationSuite={this.props.closeCreationSuite}
            handleCreationSuiteUpload={this.props.handleCreationSuiteUpload}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default Video;
